import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>404</h1>
            <h1>Page Not Found</h1>
        </div>
    );
};

export default Notfound;